import { use, useEffect, useState } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import "./css/CadastroAdm.css"
import axios from "axios";
import CardNotification from "../components/CardNotification";

const CadastroAdm = () =>{
    const [statusMessage, setStatusMessage] = useState({message : '', success:false});
    const [nome, setNome] = useState('');
    const [senha, setSenha] = useState('');
    const [email, setEmail] = useState('');
    const [cpf, setCpf] = useState('');
    const [status] = useState(true);
    const [selecaoInstituicao, setSelecaoInstituicao] = useState('');
    const [instituicoes, setInstitucoes] = useState([]);
    const [showCard, setShowCard] = useState(false);


    const handleSubmit = async(event) => {
        event.preventDefault();
        if(!nome || !cpf || !email || !senha){
            setStatusMessage({message: 'Preencha todos os campos!', success: false});
            setShowCard(true);
            return;
        }



        const formData = new FormData();
        formData.append("nome", nome);
        formData.append("email", email);
        formData.append("cpf", cpf);
        formData.append("senha", senha);
        formData.append("id_instituicao", selecaoInstituicao);
        formData.append("status", status);       

        try{
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/register`, 
                formData,{
                    headers:{
                        "Content-Type": "multipart/form-data" // TEM DE SER CORRIGIDO
                    },
                    withCredentials:true,
            });
            setStatusMessage({ message: 'Usuario cadastrado e liberado!', success: true });
            setShowCard(true);
           
        } catch(error){
            console.error(error);
            setStatusMessage({ message: "Erro ao cadastrar. Tente novamente.", success: false });
            setShowCard(true);
        }

    }

    useEffect(()=>{
        const fetchInstituicao = async()=>{
            try{
                const response = await axios.get(`${process.env.REACT_APP_API_URL}/instituicao`,
                    {
                withCredentials: true, // NOT WORKING
                }   
                );
                setInstitucoes(response.data);
            } catch(error){
                setStatusMessage({message: 'Erro ao carregar Instituições ou Administrador', success: false});
                setShowCard(true);
            }
        }
        fetchInstituicao();
    }, [])

   

    useEffect( ()=> {
        if(showCard){
            setTimeout(()=>{
                setShowCard(false);
            }, 5000);
        }
    }, [showCard]);

    return (
        <div className="Cadastroadm">
            <Header/>
            <Sidebar/>
            {statusMessage.message && showCard && (
                    <CardNotification
                        message={statusMessage.message} 
                        type={statusMessage.success ? 'success' : 'error'} 
                        onClose={() => setShowCard(false)} 
                    />
                )}
            <div className="pre-form">
                <h1>Cadastrar Usuário</h1>
                <form onSubmit={handleSubmit} className="form-adm">
                    <div className="label-input">
                        <label>Nome: </label>
                        <input type="text" value={nome} onChange={(e)=>setNome(e.target.value)}></input>   
                    </div>

                    <div className="label-input">
                        <label>Email: </label>
                        <input type="text" value={email} onChange={(e)=>setEmail(e.target.value)}></input>   
                    </div>

                    <div className="label-input">
                        <label>Senha <strong>(Não esquecer)</strong>: </label>
                        <input type="password" autoComplete="new-password" value={senha} onChange={(e)=>setSenha(e.target.value)}></input>   
                    </div>

                    <div className="label-input">
                        <label>CPF: </label>
                        <input type="text" value={cpf} onChange={(e)=>setCpf(e.target.value)}></input>   
                    </div>


                    <div className="label-input">
                        <label>Escolha a Instituição ou Administrador:</label>
                        <select value={selecaoInstituicao} onChange={(e)=>setSelecaoInstituicao(e.target.value)} required>
                        <option value="">Selecione uma Instituição ou Administrador</option>
                        {instituicoes.map((instituicao) => (
                            <option key={instituicao.id} value={instituicao.id}>
                                {instituicao.nome_instituicao}
                            </option>
                        ))}
                        </select> 
                    </div>

                    <button type="submit" className="cadastrar-modelo-button">Cadastrar</button>    
                </form>
            </div>
        </div>
    );

}

export default CadastroAdm;